exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:576px) and (max-width:767px){.H2{font-size:32px!important}}@media (max-width:575px){.H2{font-size:32px!important}}body{font-family:Open Sans,sans-serif;background:#f8f8f8;margin:0;height:100%;z-index:1000;color:#696e74}.H2{padding:0;margin:0 0 20px;font-size:38px;font-weight:500;text-align:center;text-transform:uppercase;font-family:Open Sans Condensed,sans-serif;color:#252525}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07f1503b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 211
// module chunks = 0